import { createAction } from 'redux-actions';

export const selectReceiver = createAction('CERTIFICATE_SELECT_RECEIVER');
export const selectCountryOrRegistry = createAction(
  'CERTIFICATE_SELECT_COUNTRY_OR_REGISTRY'
);
